// pages/Stats.js
export default function Stats() {
    return (
      <div className="stats-container">
        <h1>Network Statistics</h1>
        <p>Global mining statistics and token metrics</p>
        {/* Add stats components */}
      </div>
    );
  }